module.exports = __webpack_public_path__ + "static/media/nav-server.5f81e3c8.svg";